export default __webpack_public_path__ + "static/media/ennovate_12.994f41b2.jpg";